import { sagas as accountSettingsSagas } from './modules/accountSettings'
import { sagas as profileSagas } from './modules/profile'
import { sagas as roommatePreferenceSagas } from './modules/roommatePreference'

export default [
  ...accountSettingsSagas,
  ...profileSagas,
  ...roommatePreferenceSagas,
]
